import { z } from "zod";
import { createRouter, query } from "react-safe-query";

const V3_CRUD_API_BASE_URL = "https://crud.v3.invintusmedia.com";
const WSC_API_KEY = "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU";

const getSecurityRolesPayloadSchema = z.object({
  clientID: z.string(),
});

export const authRouter = createRouter({
  getSession: query(async () => {
    // Since we're on the client side, we can use Auth0 hooks
    // to get the session information.
    // We'll handle this in the hook implementation.
  }),
  getSecretMessage: query(async () => {
    // We'll implement this in the hook, ensuring the user is authenticated.
  }),
  getSecurityRoles: query(async (input: z.infer<typeof getSecurityRolesPayloadSchema>) => {
    const response = await fetch(`${V3_CRUD_API_BASE_URL}/SecurityRoles/getSecurityRoles`, {
      method: "POST",
      headers: {
        authorization: "console",
        "wsc-api-key": WSC_API_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(input),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch security roles");
    }

    const data = await response.json();
    return data;
  }),
});
